// @spec GHG-STR-011
'use client';

import { Navigate, createFileRoute } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/activity-data/import')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.collectData'),
  }),
  component: ActivityDataImportRedirect,
});

function ActivityDataImportRedirect() {
  return <Navigate to="/ghg/collect" replace />;
}
